export default "__VITE_ASSET__C4mESG1$__"